import { make } from "vuex-pathify";

const initialState = {
    featureFlags: _.get(window, "_CS_FEATURE_FLAGS", null),
};

const mutations = {
    ...make.mutations(initialState),
};

const getters = {};

const actions = {
    ...make.actions(initialState),
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions,
};
